import dayjs from 'dayjs';

function getColumns({ t }) {

  return [
    {
      key: 'time',
      dataIndex: 'time',
      width: 180,
      fixed: 'left',
      title: t('tables.notifications_alarms.columns.date'),
      render: (time) => {

        const dateFormat = dayjs(time).format('YYYY/MM/DD - HH:mm');
        return dateFormat;

      },
    },
    {
      key: 'device',
      dataIndex: 'device',
      width: 160,
      title: t('tables.notifications_alarms.columns.device'),
    },
    {
      key: 'device_type',
      dataIndex: 'device_type',
      width: 160,
      title: t('tables.notifications_alarms.columns.device_types'),
    },
    {
      key: 'gateway',
      dataIndex: 'gateway',
      width: 160,
      title: 'Gateway',
    },
    {
      key: 'origin',
      dataIndex: 'origin',
      width: 160,
      title: t('tables.notifications_alarms.columns.origin'),
    },
    {
      key: 'severity',
      dataIndex: 'severity',
      width: 160,
      title: t('tables.notifications_alarms.columns.severity'),
      filterMultiple: true,
      filters: [
        { text: 'critical', value: 'Critical' },
        { text: 'warning', value: 'Warning' },
        { text: 'info', value: 'Info' },
      ],
    },
    {
      key: 'rule_content',
      dataIndex: 'rule_content',
      width: 270,
      title: t('tables.notifications_alarms.columns.alarm_name'),
      render: (rule_content) => rule_content.name,
    },
    {
      key: 'rule_content',
      dataIndex: 'rule_content',
      width: 300,
      title: t('tables.notifications_alarms.columns.description'),
      render: (rule_content) => rule_content.description,
    },
  ];

}

export default getColumns;
